import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@tyro/i18n';
import { ChevronRightIcon } from '@tyro/icons';
import {
  useReaderActions,
  useReaderState,
} from '../../store/documentation-reader-provider';

export function ReaderBreadcrumb() {
  const { t } = useTranslation(['documentation']);
  const { navigate } = useReaderActions();
  const { currentSpace, currentPageDetail, view } = useReaderState();

  const pageTitle = currentPageDetail?.page?.title ?? '';

  return (
    <Box
      sx={{
        px: 3,
        py: 1.5,
        borderBottom: 'solid 1px',
        borderBottomColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.5} flexWrap="wrap">
        <Link
          component="button"
          type="button"
          variant="body2"
          underline="hover"
          color="text.secondary"
          onClick={() => navigate({ view: 'home' })}
        >
          {t('documentation:reader.help')}
        </Link>
        {currentSpace && (
          <>
            <ChevronRightIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
            {view === 'page' ? (
              <Link
                component="button"
                type="button"
                variant="body2"
                underline="hover"
                color="text.secondary"
                onClick={() =>
                  navigate({ view: 'space', spaceId: currentSpace.id })
                }
              >
                {currentSpace.name}
              </Link>
            ) : (
              <Typography variant="body2" color="text.primary">
                {currentSpace.name}
              </Typography>
            )}
          </>
        )}
        {view === 'page' && pageTitle && (
          <>
            <ChevronRightIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
            <Typography variant="body2" color="text.primary" noWrap>
              {pageTitle}
            </Typography>
          </>
        )}
      </Stack>
    </Box>
  );
}
